<template>
  <div class="add-applicant-component">

    <select-online-or-offline-inner
      v-if="!copyOrder"
      :offline.sync="innerOffline"
      :is-support-offline="isSupportOffline"
    ></select-online-or-offline-inner>

    <div class="depart-date-box">
      <div class="depart-title">预计出行时间</div>
      <div class="depart-select">
        <holiday-date-picker
          class="depart-date-select"
          :depart-date="innerDepartDate"
          :holiday-date-arr="holidayArr"
          :min-disabled-date="disabledDate"
          :show-early="true"
          @input="($event) => innerDepartDate = $event"
        ></holiday-date-picker>
      </div>
    </div>


    <!-- excel导入申请人 -->
    <div class="batch-import-box" v-if="layout.showBatchImport">
      <div class="import-title">申请人人信息</div>
      <import-order
        :product="product"
        @success="batchImportSuccess"
        @closeImport="layout.showBatchImport = false"
      ></import-order>
    </div>
    
    <!-- 下面都是普通的添加申请人 -->
    <div class="applicant-list-box" v-show="!layout.showBatchImport">
      <div class="applicant-header">
        <div class="left-box">
          <div class="header-title">申请人信息</div>
          <div class="applicant-num">（共{{innerApplicantList.length}}人）</div>
        </div>
        <div class="right-box" v-if="!otaOrderInfo">
          
          <div class="batch-import-btn" @click="onShowBatchImport">
            <img class="icon" src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-btn-import.png" alt="">
            批量上传名单
          </div>
          <button v-if="!offline" class="handle-btn"  @click="startSelectHistoryApplicant()">
            <img class="icon" src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-btn-history.png" alt="">
            历史申请人
          </button>

          <base-popover-with-close
            v-if="passportOrIDcard && !offline"
            position="top-right"
            storage-key="showed-created-order-batch-ocr-btn"
            :content="`无需手动输入，拍摄${passportOrIDcard === 2 ? '护照' : '身份证'}直接上传，系统自动识别`"
          >
            <button class="handle-btn primary" :disabled="ocrUploading" @click="onBatchSelectOcrFile()">
              <img class="icon" src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-btn-passport.png" alt="">
              批量上传{{passportOrIDcard === 2 ? '护照' : '身份证'}}
            </button>
          </base-popover-with-close>
        </div>
      </div>
      <div class="applicant-table-box base-scroller" ref="tableBox">
        <div class="applicant-item" v-for="(item, index) in innerApplicantList" :key="index">
          <div class="item-index">{{index + 1}}</div>
          <!-- 飞猪线下订单表单 -->
          <fliggy-offline-applicant-form
            v-if="isOtaOffline"
            :applicant-item="item"
            :change-applicant-item-field-fn="changeApplicantItemField"
            :submited="layout.submited"
            :identityList="identityList"
            :isUniversalIdentity="isUniversalIdentity"
          ></fliggy-offline-applicant-form>

          <div v-else class="applicant-item-body" :class="{'has-ocr': hasAnyOcr}">
            <div class="left-box">
              <div v-if="hasAnyOcr" class="item-ocr-img" >
                <div class="ocr-img-box" v-if="item.file_url" @click="previewImage(item.file_url)">
                  <img
                    class="ocr-img"
                    :src="item.file_url"
                  />
                  <div v-if="[0, 1, 3].indexOf(item.ocr_status) > -1" class="ocr-status">
                    <img v-if="[0, 1].indexOf(item.ocr_status) > -1" class="icon loading" src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-uploading.png" alt="">
                    <img v-if="[3].indexOf(item.ocr_status) > -1" class="icon" src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-error.png" alt="">
                  </div>
                </div>
              </div>
              <div
                class="form-item"
                :class="{'is-error': isNeedShowError(item, 'applicant_name') && (!item.applicant_name || item.applicant_name.trim().length < 2) }"
              >
                <div class="item-label">姓名</div>
                <div class="item-content">
                  <el-input
                    v-if="!item.archives_id && !item.applicant_id"
                    :value="item.applicant_name"
                    @input="($event) => changeApplicantItemField($event, 'applicant_name', item)"
                    placeholder="请输入姓名"
                    :maxlength="40"
                    :minlength="2"
                    @blur="changeApplicantItemField(true, 'show_error_applicant_name', item)"
                  ></el-input>
                  <div class="view-applicant-name" v-else>
                    <div class="applicant-name" :title="item.applicant_name">{{item.applicant_name}}</div>
                    <div v-if="item.archives_id" class="archive-tag">复用</div>
                    <div v-if="item.applicant_id" class="archive-tag">复制</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right-box" v-if="!isUniversalIdentity">
              <div
                class="form-item identity"
                :class="{'is-error': isNeedShowError(item, 'identity_id') && item.identity_id === undefined }"
              >
                <div class="item-label">旅客身份</div>
                <div class="item-content">
                  <el-select
                    :value="item.identity_id"
                    @input="($event) => changeApplicantItemField($event, 'identity_id', item)"
                    placeholder="选择身份"
                    popper-class="go-select"
                  >
                    <el-option
                      :label="identitys[identity]"
                      :value="identity"
                      v-for="(identity, idx) in identityList"
                      :key="'identity_' + idx"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          
          <div class="item-delete">
            <img
              class="icon-delete"
              src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-applicant-delete.png"
              v-if="innerApplicantList.length > 1 && !isDisabledDeleteApplicant"
              @click="deleteApplicant(index)"
            />
          </div>
        </div>
      </div>
      <div v-if="otaOrderInfo" class="ota-tips">请仔细核对出行人信息与飞猪申请人信息是否一致</div>
      <div class="add-applicant-box">
        <div class="add-applicant" :class="{'disabled': innerApplicantList.length === maxApplicantNum}"  @click="addApplicant">
          <div class="add-icon"></div>
          <div class="add-text">新增申请人</div>
        </div>
      </div>
    </div>
    <div class="applicant-footer" v-show="!layout.showBatchImport">
      <button v-if="!otaOrderInfo && !copyOrder" class="share-btn" @click="onShareProduct()">分享给顾客</button>
      <el-button
        type="primary"
        class="start-add-order"
        :disabled="submitting || ocrUploading"
        @click="startAddOrder()"
      >下一步</el-button>
    </div>

  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import HolidayDatePicker from '../../../holiday-date-picker';
import Http from '@/libs/http';
import moment from 'moment';
import addNewOrderService from '../../../../services/add-new-order-service';
import statusMap from '@/libs/status';
import ImportOrder from '../../import-order.vue';
import fileService from '../../../../services/file-service';
import BasePopoverWithClose from '../../../common/popover/base-popover-with-close.vue';
import FliggyOfflineApplicantForm from './ota/fliggy-offline-applicant-form.vue';
import SelectOnlineOrOfflineInner from './select-online-or-offline-inner.vue';

export default {
  components: {
    HolidayDatePicker,
    ImportOrder,
    BasePopoverWithClose,
    FliggyOfflineApplicantForm,
    SelectOnlineOrOfflineInner,
  },
  props: {
    departDate: String,
    applicantList: Array,
    offline: Number,
    isSupportOffline: Boolean,
    holidays: Array,
    product: Object,
    passportOrIDcard: Number,
    isUniversalIdentity: Boolean,
    identityList: Array,
    submitting: Boolean,
    ocrUploading: Boolean,
    otaOrderInfo: Object,
    copyOrder: Object,
  },
  data() {
    return {
      identitys: statusMap.identity, // 所有身份
      earliestDepartDate: '', // 最早可出行日期
      
      layout: {
        showBatchImport: false, // 显示批量导入名单
        submited: false, // 是否提交过
        ocrUploading: false, // ocr识别中
      },
    };
  },
  computed: {
    innerOffline: {
      get() {
        return this.offline;
      },
      set(value) {
        this.$emit('update:offline', value);
      },
    },
    innerDepartDate: {
      get() {
        return this.departDate ? new Date(this.departDate) : undefined;
      },
      set(value) {
        this.$emit('update:depart-date', value ? value.format('yyyy-MM-dd') : undefined);
      },
    },
    innerApplicantList: {
      get() {
        return this.applicantList;
      },
      set(value) {
        this.$emit('update:applicant-list', value);
      },
    },
    maxApplicantNum() {
      if (this.otaOrderInfo) {
        return this.otaOrderInfo.item_num;
      }
      return 200;
    },
    // 禁用的日期
    disabledDate() {
      return addNewOrderService.handleDisabledDate(
        this.earliestDepartDate,
      );
    },
    // 假期
    holidayArr() {
      return addNewOrderService.handleHolidayArr(
        this.holidays,
        this.disabledDate,
      );
    },
    hasAnyOcr() {
      return this.innerApplicantList.some(item => item.file_url);
    },
    // 是否是飞猪线下订单
    isOtaOffline() {
      if (this.otaOrderInfo && this.otaOrderInfo.ota_offline) {
        return true;
      }
      return false;
    },
    // 是否允许删除申请人
    isDisabledDeleteApplicant() {
      // 飞猪线上订单，不允许删除申请人
      if (this.otaOrderInfo && !this.otaOrderInfo.ota_offline) {
        return true;
      }
      return false;
    },
  },
  watch: {
    innerOffline: {
      handler() {
        this.changeOffline();
      },
      immediate: true,
    },
  },
  created() {
  },
  methods: {
    // 页面返回触发
    async customPageBack() {
      // 显示批量，点击页面返回需要先关闭
      if (this.layout.showBatchImport) {
        this.layout.showBatchImport = false;
        return Promise.reject();
      }
    },
    // 获取最早可出行日期
    async getEarliestDepartDate() {
      const res = await Http.post('/sys/visa_product_earliest_depart_date_query', {
        visa_product_id: this.product.visa_product_id,
        offline: this.offline,
      });
      this.earliestDepartDate = res.earliest_depart_date;

      if (moment(this.innerDepartDate).isBefore(this.earliestDepartDate, 'day')) {
        // 当前选择出行日期早于最早可出行日期，则清空
        this.innerDepartDate = '';
      }
    },
    // 是否需要显示错误
    isNeedShowError(item, field) {
      return this.layout.submited || item[`show_error_${field}`];
    },
    // 修改字段，主要是为了用$set触发更改,否则可能不生效
    changeApplicantItemField(value, field, item) {
      this.$set(item, field, value);
    },
    // 添加申请人 
    addApplicant() {
      if (this.innerApplicantList.length >= this.maxApplicantNum) return;
      const applicantItem = {
        identity_id: this.identityList.length === 1 ? this.identityList[0] : undefined,
      };
      this.innerApplicantList.push(applicantItem);
      // 滚动到最底部
      this.$nextTick(() => {
        this.$refs.tableBox.scrollTop = this.$refs.tableBox.scrollHeight - this.$refs.tableBox.clientHeight;
      });
    },
    deleteApplicant(index) {
      this.innerApplicantList.splice(index, 1);
    },
    // 批量导入名单成功
    batchImportSuccess({ applicants }) {
      this.innerApplicantList = applicants;
    },
    previewImage(url) {
      this.$viewerApi({
        images: [url],
      });
    },
    // 批量上传OCR图片
    async onBatchSelectOcrFile() {
      try {
        sensorsdata.track('ElementClick', {
          page_from: '商品详情页-添加申请人',
          click_content: `批量上传${this.passportOrIDcard === 2 ? '护照' : '身份证'}`,
        });
        const files = await fileService.chooseFile({
          multiple: true,
          accept: 'image/png,image/jpeg',
          checkOptions: {
            acceptErrorMsg: '仅支持上传png、jpg格式的图片', 
          },
        });
        if (files.length > 20) {
          this.$message.error('一次最多上传 20 张图片');
          return;
        }
        if (files.length + this.innerApplicantList.length > this.maxApplicantNum) {
          this.$message.error(`每个订单最多添加${this.maxApplicantNum}个申请人，请重新选择`);
          return;
        }

        files.forEach((file) => {
          // 如果找到了空的申请人，则不新增，直接替换
          const nullApplicantItem = this.innerApplicantList.find((item) => {
            // 可选择的身份只有一个，则会默认选中，所以这里判断一下
            const isDefaultIdentity = item.identity_id === undefined || this.identityList.length === 1;
            return !item.applicant_name && isDefaultIdentity && !item.file;
          });
          if (nullApplicantItem) {
            this.changeApplicantItemField(0, 'ocr_status', nullApplicantItem);
            this.changeApplicantItemField(file, 'file', nullApplicantItem);
            this.changeApplicantItemField(URL.createObjectURL(file), 'file_url', nullApplicantItem);
          } else {
            const applicantItem = {
              ocr_status: 0, // 0：待上传 1：上传中，2：识别成功，3：识别失败
              file,
              file_url: URL.createObjectURL(file),
            };
            this.innerApplicantList.push(applicantItem);
          }
        });
        // 滚动到最底部
        this.$nextTick(() => {
          this.$refs.tableBox.scrollTop = this.$refs.tableBox.scrollHeight - this.$refs.tableBox.clientHeight;
        });

        this.$emit('startUploadOcr');
      } catch (error) {
        //
      }
    },

    // 线上线下切换了，需要处理出行日期非法和身份非法的问题
    async changeOffline() {
      this.getEarliestDepartDate();
      this.innerApplicantList.forEach((item) => {
        if (item.identity_id !== undefined && !this.identityList.includes(item.identity_id)) {
          this.changeApplicantItemField(undefined, 'identity_id', item);
        }
      });
    },

    
    // 提交订单
    async startAddOrder() {
      if (this.submitting) return;

      this.layout.submited = true;
      
      this.$emit('submit');
    },

    onShowBatchImport() {
      sensorsdata.track('ElementClick', {
        page_from: '商品详情页-添加申请人',
        click_content: '批量上传名单',
      });
      this.layout.showBatchImport = true;
    },

    // 开始选择历史申请人
    startSelectHistoryApplicant() {
      sensorsdata.track('ElementClick', {
        page_from: '商品详情页-添加申请人',
        click_content: '添加历史申请人',
      });
      this.$emit('go-next-page', 3);
    },
    onShareProduct() {
      this.$emit('share-product');
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/less/variable";

.add-applicant-component{
  padding: 20px 32px 32px 32px;
  line-height: 1;
  .depart-date-box{
    margin-top: 24px;
    padding-bottom: 20px;
    .depart-title{
      color: #2F333D;
      font-size: 16px;
      margin-bottom: 16px;
      font-weight: 600;
    } 
  }
  .batch-import-box{
    padding-top: 20px;
    .import-title{
      color: #2F333D;
      font-size: 16px;
      margin-bottom: 16px;
      font-weight: 600;
    } 
  }
  .applicant-list-box{
    padding-top: 20px;
    .applicant-header{
      margin-bottom: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left-box{
        display: flex;
        align-items: center;
        .header-title{
          color: #2F333D;
          font-size: 16px;
          line-height: 28px;
          font-weight: 600;
        }
        .applicant-num{
          margin-left: 4px;
          font-size: 14px;
          color: #FF6464;
        }
      }
      .right-box{
        display: flex;
        align-items: center;
        gap: 16px;
        .batch-import-btn{
          cursor: pointer;
          color: #599FFF;
          display: flex;
          align-items: center;
          .icon{
            width: 16px;
            height: 17px;
            margin-right: 4px;
          }
        }
        .handle-btn{
          height: 28px;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 0 8px;
          border: 1px solid #599FFF;
          color: #599FFF;
          font-size: 14px;
          background: #fff;
          border-radius: 4px;
          line-height: 1;
          .icon{
            width: 16px;
            height: 17px;
            margin-right: 4px;
          }
          &.primary{
            background: #599FFF;
            color: #fff;
          }
          &[disabled]{
            opacity: 0.7;
            cursor: not-allowed;
          }
        }
      }
    }
    .applicant-table-box{
      margin-top: 16px;
      width: 100%;
      max-height: 328px;
      overflow-y: auto;
      background: #F7F8FA;
      padding: 16px 0;
      .applicant-item{
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        &:last-child{
          margin-bottom: 0;
        }
        .item-index{
          flex-shrink: 0;
          width: 48px;
          padding-left: 16px;
          color: #2F333D;
          font-size: 14px;
        }
        .applicant-item-body{
          flex-grow: 1;
          overflow: hidden;
          border: 1px solid #DEE2E6;
          display: flex;
          background: #fff;
          border-radius: 2px;
          .left-box, .right-box{
            flex: 1;
            display: flex;
            position: relative;
            overflow: hidden;
          }
          .right-box{
            &::before{
              content: "";
              position: absolute;
              top: 8px;
              bottom: 8px;
              left: 0;
              width: 1px;
              background: #E9EEF2;
            }
          }
          .item-ocr-img{
            padding: 8px;
            width: 82px;
            height: 62px;
            position: relative;
            &::before{
              content: "";
              position: absolute;
              top: 12px;
              bottom: 12px;
              right: 0;
              width: 1px;
              background: #E9EEF2;
            }
            .ocr-img-box{
              position: relative;
              cursor: pointer;
              .ocr-img{
                width: 66px;
                height: 46px;
                object-fit: cover;
              }
              .ocr-status{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.6);
                .icon {
                  width: 16px;
                  height: 17px;
                  position: absolute;
                  right: 6px;
                  bottom: 6px;
                  &.loading{
                    animation: spin 1s linear infinite;
                    @keyframes spin {
                      from {
                          transform: rotate(0deg);
                      }
                      to {
                          transform: rotate(360deg);
                      }
                    }
                  }
                }
              }
            }
          }
          .form-item{
            flex: 1;
            overflow: hidden;
            display: flex;
            align-items: center;
            position: relative;
            min-height: 40px;
            &.is-error{
              .item-label{
                color: #ff5a60;
              }
            }
            &.identity{
              .item-label{
                width: 96px;
              }
            }
           
            .item-label{
              padding-left: 15px;
              overflow: hidden;
              display: flex;
              align-items: center;
              width: 68px;
              flex-shrink: 0;
              color: #5F666E;
            }
            .item-content{
              flex-grow: 1;
              overflow: hidden;
              height: 100%;
              /deep/ .el-input{
                height: 100%;
                .el-input__inner{
                  border: none;
                  height: 100%;
                  padding: 0;
                  padding-right: 15px;
                  color: #2F333D;
                }
              }
              /deep/ .el-select{
                height: 100%;
                .el-input__icon{
                  color: #91999F;
                }
              }
              .view-applicant-name{
                height: 100%;
                display: flex;
                align-items: center;
                padding-right: 8px;
                .applicant-name{
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                .archive-tag{
                  flex-shrink: 0;
                  margin-left: 4px;
                  font-size: 12px;
                  background: rgba(58, 165, 255, 0.08);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  height: 16px;
                  padding: 0 4px;
                  color: #599FFF;
                }
              }

            }
          }
          &.has-ocr{
            .right-box{
              &::before{
                top: 12px;
                bottom: 12px;
              }
            }
          }

        }
        .item-delete{
          padding: 0 16px;
          flex-shrink: 0;
          min-width: 53px;
          .icon-delete{
            width: 21px;
            height: 21px;
            cursor: pointer;
          }
        }

      }
    }
    .ota-tips{
      color: #FF5A60;
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
    }
    .add-applicant-box{
      margin-top: 16px;
      display: flex;
      justify-content: center;
      .add-applicant{
        height: 36px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        color: #599FFF;
        cursor: pointer;
        font-size: 16px;
        background: rgba(89,159,255,0.08);
        border-radius: 18px;
        .add-icon{
          width: 16px;
          height: 17px;
          margin-right: 8px;
          background: url(https://o.666visa.cn/static/ssqpeer/product/created-order/icon-btn-add.png) no-repeat center / 100% 100%;
        }
        &.disabled{
          opacity: 0.7;
          cursor: not-allowed;
        }
      } 
    }
  }
  .applicant-footer{
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    .share-btn{
      width:162px;
      height:48px;
      background:#fff;
      border-radius:4px;
      border: 1px solid #599FFF;
      font-size:18px;
      color: #599FFF;
      cursor: pointer;
      outline: none;
      margin-right: 40px;
    }
    .start-add-order{
      width: 162px;
      height: 48px;
      background: #599FFF;
      &[disabled]{
        opacity: 0.7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/created-order/components/add-applicant.vue